import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import React__default, { useState } from 'react';

const getWidth = (width) => Math.max(Math.min(width + 16, 900), 300);
const useContainedImageSize = ({ width }) => {
  const imageRef = React__default.useRef(null);
  const [imgWidth, setImgWidth] = React__default.useState(getWidth(width || 400));
  const [loaded, setImgLoaded] = useState(false);
  const imgWidthRef = React__default.useRef(imgWidth);
  imgWidthRef.current = imgWidth;
  useClientLayoutEffect(() => {
    const imgRef = imageRef.current;
    if (!imgRef) {
      return;
    }
    const onLoad = () => {
      if (imgWidthRef.current) return;
      const nextWidth = getWidth(imgRef.naturalWidth);
      setImgWidth(nextWidth);
      setImgLoaded(true);
    };
    imgRef.addEventListener("load", onLoad);
    return () => {
      imgRef.removeEventListener("load", onLoad);
    };
  }, [
    imageRef
  ]);
  return React__default.useMemo(() => ({
    imgWidth,
    imageRef,
    loaded
  }), [
    imgWidth,
    imageRef,
    loaded
  ]);
};

export { useContainedImageSize };
//# sourceMappingURL=useContainedImageSize.js.map
